module.exports = __webpack_public_path__ + "static/media/dapIcon.8e6f209d.png";